import React, { useState, useRef, useMemo } from 'react';
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import DataGrid from '@inovua/reactdatagrid-enterprise';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend,
    BarElement,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, Title, Tooltip, Legend, BarElement);

const pendingHS_MCData = [
    {
        mcoName: "Molina Healthcare of Nebraska",
        reportName: "Appeals Log",
        refNo: "NHH-MT-0001",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/16/2025 11:50:54:407 AM",
        reviewStatus: "In Review",
        updatedDate: "05/16/2025 11:50:54:407 AM"
    },
    {
        mcoName: "Nebraska Total Care",
        reportName: "Call Center Report",
        refNo: "NHH-MT-0005",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/17/2025 03:50:24:328 PM",
        reviewStatus: "In Review",
        updatedDate: "05/17/2025 03:50:24:328 PM"
    },
    {
        mcoName: "Molina Healthcare of Nebraska",
        reportName: "Care Management Log",
        refNo: "NHH-MT-0002",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/19/2025 11:50:54:407 AM",
        reviewStatus: "In Review",
        updatedDate: "05/19/2025 11:50:54:407 AM"
    },
    {
        mcoName: "Molina Healthcare of Nebraska",
        reportName: "Third Party Resource",
        refNo: "NHH-MT-0015",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/19/2025 03:50:24:328 PM",
        reviewStatus: "In Review",
        updatedDate: "05/19/2025 03:50:24:328 PM"
    },
    {
        mcoName: "Nebraska Total Care",
        reportName: "Appeals Log",
        refNo: "NHH-MT-0001",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/17/2025 03:50:24:328 PM",
        reviewStatus: "In Review",
        updatedDate: "05/20/2025 11:50:54:407 AM"
    },
    {
        mcoName: "UnitedHealthcare Community Plan of Nebraska",
        reportName: "Appeals Log",
        refNo: "NHH-MT-0001",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/17/2025 03:50:24:328 PM",
        reviewStatus: "In Review",
        updatedDate: "05/17/2025 03:50:24:328 PM"
    },
    {
        mcoName: "Nebraska Total Care",
        reportName: "State Fair Hearings Log",
        refNo: "NHH-MT-0013",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Resubmitted",
        submissionDate: "05/19/2025 11:50:54:407 AM",
        reviewStatus: "In Review",
        updatedDate: "05/19/2025 11:50:54:407 AM"
    },
    {
        mcoName: "UnitedHealthcare Community Plan of Nebraska",
        reportName: "Third Party Resource",
        refNo: "NHH-MT-0015",
        frequency: "Monthly",
        period: "04/01/2025 - 04/30/2025",
        dueDate: "5/15/2025",
        submissionStatus: "Submitted",
        submissionDate: "05/15/2025 03:50:24:328 PM",
        reviewStatus: "In Review",
        updatedDate: "05/15/2025 03:50:24:328 PM"
    },
];
const over10DaysDAData = [
    {
        mcoName: "Molina Healthcare of Nebraska",
        reportName: "Third Party Resource",
        refNo: "NHH-MT-0015",
        frequency: "Monthly",
        period: "03/01/2025 - 03/31/2025",
        dueDate: "4/15/2025",
        submissionStatus: "Resubmitted",
        submissionDate: "04/21/2025 03:50:24:223 PM",
        reviewStatus: "Approved",
        updatedDate: "05/19/2025 03:50:24:328 PM"
    },
     {
        mcoName: "Nebraska Total Care",
        reportName: "Appeals Log",
        refNo: "NHH-MT-0001",
        frequency: "Monthly",
        period: "03/01/2025 - 03/31/2025",
        dueDate: "4/15/2025",
        submissionStatus: "Resubmitted",
        submissionDate: "04/24/2025 11:11:54:407 AM",
        reviewStatus: "Approved",
        updatedDate: "05/20/2025 09:23:43:342 AM"
    },
     {
        mcoName: "UnitedHealthcare Community Plan of Nebraska",
        reportName: "Appeals Log",
        refNo: "NHH-MT-0001",
        frequency: "Monthly",
        period: "03/01/2025 - 03/31/2025",
        dueDate: "4/15/2025",
        submissionStatus: "Resubmitted",
        submissionDate: "05/02/2025 04:29:24:328 PM",
        reviewStatus: "Approved",
        updatedDate: "05/17/2025 03:50:24:112 PM"
    },
]
const pendingHS_MCColumns = [
    { name: 'mcoName', header: 'MCO NAME' },
    { name: 'reportName', header: 'REPORT NAME' },
    { name: 'refNo', header: 'REF NO.' },
    { name: 'frequency', header: 'FREQUENCY' },
    { name: 'period', header: 'PERIOD' },
    { name: 'dueDate', header: 'DUE DATE' },
    { name: 'submissionStatus', header: 'SUBMISSION STATUS' },
    { name: 'submissionDate', header: 'SUBMISSION DATE' },
    { name: 'reviewStatus', header: 'REVIEW STATUS' },
    { name: 'updatedDate', header: 'UPDATE DATE' }
];
const over10DaysDAColumns = [
    { name: 'mcoName', header: 'MCO NAME' },
    { name: 'reportName', header: 'REPORT NAME' },
    { name: 'refNo', header: 'REF NO.' },
    { name: 'frequency', header: 'FREQUENCY' },
    { name: 'period', header: 'PERIOD' },
    { name: 'dueDate', header: 'DUE DATE' },
    { name: 'submissionStatus', header: 'SUBMISSION STATUS' },
    { name: 'submissionDate', header: 'SUBMISSION DATE' },
    { name: 'reviewStatus', header: 'REVIEW STATUS' },
    { name: 'updatedDate', header: 'UPDATE DATE' }
];
const InternalWorkManagement = ({ location }: { location: any }) => {
    const { state } = location;
    const { measure_id } = state?.recordData || {};
    const chartRef = useRef<any>(null);

    const [selectedYear, setSelectedYear] = useState('2025');
    const [selectedMonth, setSelectedMonth] = useState('All');
    const [showPendingHS_MCList, setShowPendingHS_MCList] = useState(false);
    const [showOver10DaysDAList, setShowOver10DaysDAList] = useState(false);
    const hsMcGridRef = useRef<HTMLDivElement>(null);
    const daGridRef = useRef<HTMLDivElement>(null);


    // Data for ReviewerGroupsEffeciencyAnalysis (All Months)
    const orgUnitDataAllMonths = {
        labels: [
            'AR', 'DA', 'DA-AS', 'FIN', 'FR', 'HS_P', 'HS-D', 'HS-MC', 'HS-S-BH', 'HS-S-LTC',
            'HS-S-M', 'PI-A', 'PI-I', 'PM-ADM-I', 'PM-DPC', 'PM-DPM-I', 'PM-PC', 'PM-PM-II',
            'PM-PS', 'RR', 'TPL',
        ],
        datasets: [
            {
                label: '1-2 Business Days',
                data: [33, 26, 26, 0, 30, 4, 10, 6, 10, 4, 8, 2, 6, 25, 8, 8, 41, 9, 9, 6, 2],
                backgroundColor: '#4caf50', // Green
            },
            {
                label: '3-5 Business Days',
                data: [9, 12, 12, 0, 14, 6, 6, 0, 0, 0, 12, 4, 0, 0, 0, 0, 3, 9, 12, 0, 0],
                backgroundColor: '#2196f3', // Blue
            },
            {
                label: '6-10 Business Days',
                data: [4, 4, 4, 9, 0, 0, 3, 4, 0, 0, 6, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0],
                backgroundColor: '#ffeb3b', // Yellow
            },
            {
                label: 'Over 10 Business Days',
                data: [0, 4, 4, 2, 0, 0, 0, 6, 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 0, 0],
                backgroundColor: '#ff9800', // Orange
            },
            {
                label: 'Pending',
                data: [8, 4, 4, 1, 2, 2, 5, 8, 5, 2, 4, 0, 0, 11, 4, 4, 4, 0, 0, 0, 1],
                backgroundColor: '#f44336', // Red
            },
        ],
    };

    // Data for January 2025
    const orgUnitDataJanuary2025 = {
        labels: orgUnitDataAllMonths.labels,
        datasets: [
            {
                label: '1-2 Business Days',
                data: [11, 6, 6, 0, 14, 2, 5, 2, 5, 2, 4, 0, 2, 12, 4, 4, 18, 3, 3, 2, 1],
                backgroundColor: '#4caf50',
            },
            {
                label: '3-5 Business Days',
                data: [3, 4, 4, 0, 2, 2, 2, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 3, 4, 0, 0],
                backgroundColor: '#2196f3',
            },
            {
                label: '6-10 Business Days',
                data: [4, 2, 2, 3, 0, 0, 1, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#ffeb3b',
            },
            {
                label: 'Over 10 Business Days',
                data: [0, 2, 2, 0, 0, 0, 0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
                backgroundColor: '#ff9800',
            },
            {
                label: 'Pending',
                data: [0, 0, 0, 1, 2, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#f44336',
            },
        ],
    };

    // Data for February 2025
    const orgUnitDataFebruary2025 = {
        labels: orgUnitDataAllMonths.labels,
        datasets: [
            {
                label: '1-2 Business Days',
                data: [18, 10, 10, 0, 16, 2, 5, 4, 5, 2, 4, 2, 2, 10, 4, 4, 18, 3, 3, 2, 0],
                backgroundColor: '#4caf50',
            },
            {
                label: '3-5 Business Days',
                data: [0, 4, 4, 0, 2, 2, 2, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 3, 4, 0, 0],
                backgroundColor: '#2196f3',
            },
            {
                label: '6-10 Business Days',
                data: [0, 2, 2, 3, 0, 0, 1, 2, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#ffeb3b',
            },
            {
                label: 'Over 10 Business Days',
                data: [0, 2, 2, 1, 0, 0, 0, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0],
                backgroundColor: '#ff9800',
            },
            {
                label: 'Pending',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 1],
                backgroundColor: '#f44336',
            },
        ],
    };

    // Determine which data to use based on selected year and month
    const orgUnitData =
        measure_id === 'ReviewerGroupsEffeciencyAnalysis'
            ? selectedYear === '2025' && selectedMonth === '1'
                ? orgUnitDataJanuary2025
                : selectedYear === '2025' && selectedMonth === '2'
                    ? orgUnitDataFebruary2025
                    : orgUnitDataAllMonths
            : { labels: [], datasets: [] };

    // Bar Chart Options
    const barChartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
                display: true,
            },
            title: {
                display: true,
                text: measure_id === 'ReviewerGroupsEffeciencyAnalysis'
                    ? `Reviewer Groups Efficiency Analysis (${selectedYear})`
                    : `Plan Pending Review (${selectedYear})`,
            },
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Organization Unit Codes',
                },
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: measure_id === 'ReviewerGroupsEffeciencyAnalysis'
                        ? 'Sum of Business Days'
                        : 'Count',
                },
                beginAtZero: true,
                ticks: {
                    stepSize: 10,
                },
            },
        },
    };

    // Data for PlanPendingReview (All Months)
    const planPendingReviewDataAllMonths = {
        labels: orgUnitDataAllMonths.labels,
        datasets: [
            {
                label: 'UHC',
                data: [3, 1, 1, 0, 0, 1, 0, 2, 2, 0, 1, 0, 0, 2, 2, 1, 1, 0, 0, 0, 0],
                backgroundColor: '#4caf50',
            },
            {
                label: 'NTC',
                data: [1, 0, 0, 1, 1, 1, 2, 3, 1, 1, 0, 0, 0, 3, 1, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#2196f3',
            },
            {
                label: 'MHN',
                data: [4, 3, 3, 0, 1, 0, 3, 3, 2, 1, 3, 0, 0, 4, 1, 3, 3, 0, 0, 0, 1],
                backgroundColor: '#E1AD01',
            },
        ],
    };

    // Data for PlanPendingReview (January 2025)
    const planPendingReviewDataJanuary2025 = {
        labels: orgUnitDataAllMonths.labels,
        datasets: [
            {
                label: 'UHC',
                data: [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#4caf50',
            },
            {
                label: 'NTC',
                data: [0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#2196f3',
            },
            {
                label: 'MHN',
                data: [0, 0, 0, 0, 1, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#E1AD01',
            },
        ],
    };

    // Data for PlanPendingReview (February 2025)
    const planPendingReviewDataFebruary2025 = {
        labels: orgUnitDataAllMonths.labels,
        datasets: [
            {
                label: 'UHC',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#4caf50',
            },
            {
                label: 'NTC',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                backgroundColor: '#2196f3',
            },
            {
                label: 'MHN',
                data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
                backgroundColor: '#E1AD01',
            },
        ],
    };

    // Determine which data to use based on selected year and month for PlanPendingReview
    const planPendingReviewData =
        selectedYear === '2025' && selectedMonth === '1'
            ? planPendingReviewDataJanuary2025
            : selectedYear === '2025' && selectedMonth === '2'
                ? planPendingReviewDataFebruary2025
                : planPendingReviewDataAllMonths;

    // Filter pendingHS_MCData based on selected month/year
    const filteredPendingHS_MCData = useMemo(() => {
        if (selectedMonth === 'All') return pendingHS_MCData;
        if (selectedMonth === 'All') {
            // January
            return pendingHS_MCData.filter(row => row.period.startsWith('01/01/2025'));
        }
        if (selectedMonth === 'All') {
            // February
            return pendingHS_MCData.filter(row => row.period.startsWith('02/01/2025'));
        }
        // Default: all
        return pendingHS_MCData;
    }, [selectedMonth, selectedYear]);

   
    // Add this state to hold filtered data for MHN, HS-MC
const [filteredMHN_HSMCData, setFilteredMHN_HSMCData] = useState<any[]>([]);

const handleBarClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    const chart = chartRef.current;
    if (!chart) return;
    const elements = getElementAtEvent(chart, event);

    setShowPendingHS_MCList(false);
    setShowOver10DaysDAList(false);

    if (!elements.length) return;
    const { datasetIndex, index } = elements[0];
    const dataset = (measure_id === 'PlanPendingReview' ? planPendingReviewData : orgUnitData).datasets[datasetIndex];
    const label = (measure_id === 'PlanPendingReview' ? planPendingReviewData : orgUnitData).labels[index];

    // PlanPendingReview: MHN, HS-MC
    if (
        measure_id === 'PlanPendingReview' &&
        dataset?.label === 'MHN' &&
        label === 'HS-MC'
    ) {
        // Filter for Molina Healthcare of Nebraska
        const filtered = pendingHS_MCData.filter(row => row.mcoName === "Molina Healthcare of Nebraska");
        setFilteredMHN_HSMCData(filtered);
        setShowPendingHS_MCList(true);
        setTimeout(() => {
            hsMcGridRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
    }

    // PlanPendingReview: NTC, HS-MC
    if (
        measure_id === 'PlanPendingReview' &&
        dataset?.label === 'NTC' &&
        label === 'HS-MC'
    ) {
        // Filter for Nebraska Total Care
        const filtered = pendingHS_MCData.filter(row => row.mcoName === "Nebraska Total Care");
        setFilteredMHN_HSMCData(filtered);
        setShowPendingHS_MCList(true);
        setTimeout(() => {
            hsMcGridRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
    }
    if (
        measure_id === 'PlanPendingReview' &&
        dataset?.label === 'UHC' &&
        label === 'HS-MC'
    ) {
        // Filter for United HealthCare Community Plan of Nebraska
        const filtered = pendingHS_MCData.filter(row => row.mcoName === "UnitedHealthcare Community Plan of Nebraska");
        setFilteredMHN_HSMCData(filtered);
        setShowPendingHS_MCList(true);
        setTimeout(() => {
            hsMcGridRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
    }


    // ReviewerGroupsEffeciencyAnalysis: HS-MC Pending
    if (
        measure_id === 'ReviewerGroupsEffeciencyAnalysis' &&
        dataset?.label === 'Pending' &&
        label === 'HS-MC' &&
        filteredPendingHS_MCData.length > 0
    ) {
        setShowPendingHS_MCList(true);
        setTimeout(() => {
            hsMcGridRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
    }

    // ReviewerGroupsEffeciencyAnalysis: DA Over 10 Business Days
    if (
        measure_id === 'ReviewerGroupsEffeciencyAnalysis' &&
        dataset?.label === 'Over 10 Business Days' &&
        label === 'DA' &&
        over10DaysDAData.length > 0
    ) {
        setShowOver10DaysDAList(true);
        setTimeout(() => {
            daGridRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
    }
};
    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <h2>
                        {measure_id === 'ReviewerGroupsEffeciencyAnalysis'
                            ? 'Internal Work Management - Reviewer Groups Efficiency Analysis'
                            : 'Internal Work Management - Plan Pending Review'}
                    </h2>
                </div>
            </div>

            {(measure_id === 'ReviewerGroupsEffeciencyAnalysis' || measure_id === 'PlanPendingReview') && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '10px' }}>
                    {/* Dropdown for Year */}
                    <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        style={{
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        <option value="2025">2025</option>
                        <option value="2024">2024</option>
                    </select>

                    {/* Dropdown for Month */}
                    <select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        style={{
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            cursor: 'pointer',
                        }}
                    >
                        <option value="All">All Months</option>
                        <option value="1">January</option>
                        <option value="2">February</option>
                    </select>
                </div>
            )}

            <div style={{ width: '80%', margin: '20px auto' }}>
                {measure_id === 'ReviewerGroupsEffeciencyAnalysis' && (
                    <Bar ref={chartRef} data={orgUnitData} options={barChartOptions} onClick={handleBarClick} />
                )}
                {measure_id === 'PlanPendingReview' && (
                    <Bar ref={chartRef} data={planPendingReviewData} options={barChartOptions} onClick={handleBarClick} />
                )}
            </div>
            {showPendingHS_MCList && (
                <div ref={hsMcGridRef} style={{ position: 'relative', zIndex: 20, margin: '40px auto', width: '80%' }}>
                    <DataGrid
                        licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                        idProperty="refNo"
                        style={{ minHeight: 300 }}
                        pagination
                        columns={pendingHS_MCColumns}
                        dataSource={
                // If PlanPendingReview and filteredMHN_HSMCData is set, use it, else use filteredPendingHS_MCData
                measure_id === 'PlanPendingReview' && filteredMHN_HSMCData.length > 0
                    ? filteredMHN_HSMCData
                    : filteredPendingHS_MCData
            }
                        sortable={true}
                        defaultLimit={10}
                        rowHeight={50}
                        className="pointer-cursor-row"
                        enableColumnAutosize={true}
                        pageSizes={[5, 10, 20, 30, 40, 50]}
                    />
                </div>
            )}
            {showOver10DaysDAList && (
                <div ref={daGridRef} style={{ position: 'relative', zIndex: 20, margin: '40px auto', width: '80%' }}>
                    <DataGrid
                        licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                        idProperty="refNo"
                        style={{ minHeight: 300 }}
                        pagination
                        columns={over10DaysDAColumns}
                        dataSource={over10DaysDAData}
                        sortable={true}
                        defaultLimit={10}
                        rowHeight={50}
                        className="pointer-cursor-row"
                        enableColumnAutosize={true}
                        pageSizes={[5, 10, 20, 30, 40, 50]}
                    />
                </div>
            )}
            <Footer />
        </>
    );
};

export default InternalWorkManagement;